import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
let _provider;
export function getI18nProvider() {
  if (!_provider) {
    _provider = createStandardI18nProvider();
  }
  return _provider;
}